import PropTypes from 'prop-types';
import React from 'react';
import coinsImg from '../../../../images/loans-coins.png';
import underlineImg from '../../../../images/loans-underline.png';
import Drawer from '../../common/Drawer';
import Icon, { GLYPHS } from '../../common/icon';
import Money from '../../common/money';
import DrawerModal from '../../common/DrawerModal';
import { t } from '../../../modules/infra/i18n';

const LoansDrawer = ({
  amount,
  opened,
  generatingLinkIsOn,
  decliningOfferIsOn,
  onApplyClick,
  onDeclineClick,
  onCloseDrawer,
  disclaimerVisibleIsOn,
  disclaimerVisibleOn,
  disclaimerVisibleOff,
  declineConfirmVisibleIsOn,
  declineConfirmVisibleOn,
  declineConfirmVisibleOff,
  userHasPaidOutLoan,
}) => (
  <Drawer visible={opened} onClose={onCloseDrawer}>
    <div className="c-loans" data-automation-id="loans-drawer">
      <img src={coinsImg} alt="Coins" />
      {userHasPaidOutLoan ? (
        <span className="c-loans-amount">
          {t('loans:drawer.amount_eligible_additional')} <Money cents={amount} precision={0} />
        </span>
      ) : (
        <span className="c-loans-amount">
          {t('loans:drawer.amount_receive_up_to')} <Money cents={amount} precision={0} />
        </span>
      )}
      <img src={underlineImg} alt="Underline" />
      <div className="c-loans-description">
        <p>{t('loans:drawer.growth_investment_message')}</p>
        <p>
          {t('loans:drawer.eligibility_based_on_activity')}{' '}
          <strong>
            {t('loans:drawer.financing_up_to')} <Money cents={amount} precision={0} />{' '}
            {t('loans:drawer.through_stripe_partner')}
          </strong>
          .
          <Icon glyph={GLYPHS.infoIcon} className="u-ml-- u-cursor-pointer" onClick={disclaimerVisibleOn} />
        </p>
      </div>
      <div className="c-loans-buttons u-color-white">
        <button className="c-btn c-loans-apply-btn" onClick={onApplyClick} disabled={generatingLinkIsOn}>
          {t('loans:drawer.learn_more_button')}
        </button>
        <button className="c-btn c-btn--outline" onClick={declineConfirmVisibleOn} disabled={decliningOfferIsOn}>
          {t('loans:drawer.decline_offer_button')}
        </button>
        <p className="c-loans-disclaimer">{t('loans:drawer.third_party_disclaimer')}</p>
      </div>
    </div>
    <DrawerModal onClose={disclaimerVisibleOff} isOpen={disclaimerVisibleIsOn}>
      <div className="c-loans-description">
      <p className="u-fontsize-small">
        DISCLAIMER: SQUIRE IS NOT A BANK.
        {' '}SQUIRE DOES NOT DIRECTLY PROVIDE BUSINESS LOANS OR LINES OF CREDIT.
        {' '}THIS OFFER IS FOR STRIPE, INC.’S (“<strong>STRIPE</strong>”) FINANCIAL SERVICES AND IS A PARTNER OFFER,
        {' '}AS DEFINED IN THE ENTERPRISE TERMS OF SERVICE.
        {' '}THIS PARTNER OFFER IS SUBJECT TO ADDITIONAL TERMS AND CONDITIONS.
        {' '}BY CLICKING “LEARN MORE,” YOU WILL BE TRANSFERRED TO A THIRD-PARTY WEBSITE,
        {' '}OWNED AND OPERATED BY STRIPE (“<strong>PARTNER OFFER LANDING PAGE</strong>”).
        {' '}ALTHOUGH THE PARTNER OFFER LANDING PAGE IS A
        {' '}CO-MARKETING PAGE WITH BOTH SQUIRE AND STRIPE’S COMPANY NAMES,
        {' '}LOGOS AND COPYRIGHT, SQUIRE DOES NOT OWN OR OPERATE THE PARTNER OFFER LANDING PAGE.
        {' '}SQUIRE IS NOT RESPONSIBLE FOR THE GOODS AND SERVICES OFFERED IN THE PARTNER OFFER OR
        {' '}PARTNER OFFER LANDING PAGE (“<strong>PARTNER MARKETED SERVICES</strong>”).
        {' '}SQUIRE MAKES NO WARRANTIES, REPRESENTATIONS OR UNDERTAKINGS RELATING TO THE PARTNER OFFER,
        {' '}THE PARTNER OFFER LANDING PAGE OR THE PARTNER MARKETED SERVICES.
        {' '}SQUIRE DISCLAIMS ALL LIABILITY FOR ANY LOSS, DAMAGE, AND ANY OTHER CONSEQUENCE RESULTING DIRECTLY OR
        {' '}INDIRECTLY FROM OR RELATING TO YOUR ACCESS TO THE PARTNER OFFER,
        {' '}THE PARTNER OFFER LANDING PAGE OR THE PARTNER MARKETED SERVICES.
        {' '}ANY LINK YOU MAKE TO OR FROM THE PARTNER OFFER LANDING PAGE OR ANY USE OF THE PARTNER OFFER LANDING PAGE
        {' '}WILL BE SUBJECT TO AND GOVERNED BY THE TERMS OF THE PARTNER OFFER LANDING PAGE,
        {' '}INCLUDING THOSE RELATING TO CONFIDENTIALITY, DATA PRIVACY AND SECURITY.
        {' '}ANY USE OF THE PARTNER OFFER LANDING PAGE AND THE PARTNER MARKETED SERVICES IS AT YOUR OWN RISK.
        </p>
      </div>
    </DrawerModal>
    <DrawerModal onClose={declineConfirmVisibleOff} isOpen={declineConfirmVisibleIsOn}>
      <div className="c-loans-decline-modal-content">
        <h3>{t('loans:decline_modal.title')}</h3>
        <p>{t('loans:decline_modal.warning')}</p>
      </div>
      <div className="c-loans-decline-modal-buttons u-color-white">
        <button className="c-btn c-btn--red c-loans-apply-btn" onClick={onDeclineClick} disabled={decliningOfferIsOn}>
          {t('loans:decline_modal.decline_button')}
        </button>
        <button className="c-btn c-btn--outline" onClick={declineConfirmVisibleOff}>
          {t('common:Cancel')}
        </button>
      </div>
    </DrawerModal>
  </Drawer>
);

LoansDrawer.propTypes = {
  opened: PropTypes.bool.isRequired,
  generatingLinkIsOn: PropTypes.bool.isRequired,
  decliningOfferIsOn: PropTypes.bool.isRequired,
  amount: PropTypes.number.isRequired,
  onApplyClick: PropTypes.func.isRequired,
  onDeclineClick: PropTypes.func.isRequired,
  onCloseDrawer: PropTypes.func.isRequired,
  disclaimerVisibleIsOn: PropTypes.bool.isRequired,
  disclaimerVisibleOn: PropTypes.func.isRequired,
  disclaimerVisibleOff: PropTypes.func.isRequired,
  declineConfirmVisibleIsOn: PropTypes.bool.isRequired,
  declineConfirmVisibleOn: PropTypes.func.isRequired,
  declineConfirmVisibleOff: PropTypes.func.isRequired,
  userHasPaidOutLoan: PropTypes.bool.isRequired,
};

export default LoansDrawer;
